'use strict';

var angular = require('angular');
var _ = require('lodash');
var ConfigurationUserDefinedRefDataModalController = function ConfigurationUserDefinedRefDataModalController($scope, $rootScope, urdToolbarService, dtdModal, userSecureService, urdConstants) {
  var source = {
    localdata: [],
    datatype: 'array'
  };
  var dataAdapter = new angular.element.jqx.dataAdapter(source);
  var title = '';
  var isEditable = userSecureService.hasAuthorization('user-defined-ref-data', 'write');
  $scope.REMEMBER_VALUES = true;
  function updateData(modalData) {
    source.localdata = modalData.dtds;
    $scope.gridSettings.jqxGrid('updatebounddata');
  }
  function updateHeader(modalData) {
    title = dtdModal.getHeader($scope.type, modalData);
    $scope.gridSettings.jqxGrid({
      columngroups: [{
        text: title,
        align: 'center',
        name: 'MarketGroup'
      }]
    });
  }
  function getCellClassName(rowId, dataField) {
    var rowData = $scope.gridSettings.source.records[rowId];
    return dtdModal.getCellClassName(rowData, dataField);
  }
  function getReferenceMetricType(referenceMetric, tab) {
    return _.isEqual(tab, urdConstants.HEP_TYPE.MARKET) ? urdToolbarService.getMarketReferenceMetric(referenceMetric, 'type') : urdToolbarService.getFlightReferenceMetric(referenceMetric, 'type');
  }
  var cellRenderer = function cellRenderer(rowIndex, columnName, value, cellContent) {
    if (value !== '') {
      return _.isEqual(getReferenceMetricType($scope.modalData.referenceMetric, $scope.type), urdConstants.PERCENTAGE) ? cellContent.replace('>' + value + '<', '>' + Math.round(value * 10000) / 100 + '<') : cellContent;
    }
    return cellContent;
  };
  var cellBeginEdit = function cellBeginEdit(rowIndex, datafield, columntype, value, row) {
    if (!_.isNil(value)) {
      row[datafield] = _.isEqual(getReferenceMetricType($scope.modalData.referenceMetric, $scope.type), urdConstants.PERCENTAGE) ? Math.round(value * 10000) / 100 : value;
    }
    return true;
  };
  var cellEndEdit = function cellEndEdit(rowIndex, datafield, columnType, previousValue, newValue) {
    if (!_.isNil(newValue)) {
      return _.isEqual(getReferenceMetricType($scope.modalData.referenceMetric, $scope.type), urdConstants.PERCENTAGE) ? Math.round(newValue * 1000) / 100000 : newValue;
    }
    return newValue;
  };
  $scope.$watch('type', function (newType) {
    $scope.modalElementId = _.kebabCase(newType);
    $scope.gridId = dtdModal.getGridId(newType);
  });
  $scope.$watch('modalData', function (newModalData) {
    if (newModalData && newModalData.type === $scope.type) {
      updateData(newModalData);
      updateHeader(newModalData);
    }
  });
  $scope.gridSettings = {
    width: '100%',
    height: '100%',
    altrows: true,
    editable: true,
    selectionmode: 'multiplecells',
    enablekeyboarddelete: false,
    columns: [{
      text: 'DTD',
      datafield: 'DTD',
      columngroup: 'MarketGroup',
      editable: false,
      width: 85,
      cellsalign: 'right'
    }, {
      text: 'MIN',
      datafield: 'MIN',
      columngroup: 'MarketGroup',
      editable: isEditable,
      validation: dtdModal.validateCell,
      cellclassname: getCellClassName,
      width: 85,
      cellsalign: 'right',
      cellsrenderer: cellRenderer,
      cellbeginedit: cellBeginEdit,
      cellvaluechanging: cellEndEdit
    }, {
      text: 'MAX',
      datafield: 'MAX',
      columngroup: 'MarketGroup',
      editable: isEditable,
      validation: dtdModal.validateCell,
      cellclassname: getCellClassName,
      width: 85,
      cellsalign: 'right',
      cellsrenderer: cellRenderer,
      cellbeginedit: cellBeginEdit,
      cellvaluechanging: cellEndEdit
    }, {
      text: 'AVG',
      datafield: 'AVG',
      columngroup: 'MarketGroup',
      editable: isEditable,
      validation: dtdModal.validateCell,
      cellclassname: getCellClassName,
      cellsalign: 'right',
      cellsrenderer: cellRenderer,
      cellbeginedit: cellBeginEdit,
      cellvaluechanging: cellEndEdit
    }],
    columngroups: [{
      text: 'Market DTD',
      align: 'center',
      name: 'MarketGroup'
    }],
    source: dataAdapter
  };
  $scope.saveModal = function () {
    $scope.hideModal(true).then(function () {
      $rootScope.$broadcast(dtdModal.getSaveEventName($scope.type));
    });
  };
  $scope.cancelModal = function (rememberValues) {
    $scope.hideModal(rememberValues);
  };
  $scope.markCellAsEdited = function (rowId, dataField, value, oldValue) {
    var rowData = $scope.gridSettings.source.records[rowId];
    if (!rowData._old) {
      rowData._old = {};
    } else if (typeof rowData._old === 'string') {
      rowData._old = JSON.parse(rowData._old);
    }
    rowData._old[dataField] = oldValue;
  };
  $scope.cellFillDown = function () {
    dtdModal.cellFillDown($scope.gridSettings, $scope.markCellAsEdited);
  };
  $scope.exportDTDToExcel = function () {
    var data = $scope.gridSettings.apply('exportdata', 'xls');
    dtdModal.exportDTDToExcel(data, title, $scope.gridId);
  };
};
ConfigurationUserDefinedRefDataModalController.$inject = ['$scope', '$rootScope', 'ConfigurationUserDefinedRefDataGridToolbarFunctionsService', 'DtdModalService', 'UserSecureService', 'UrdConstants'];
module.exports = ConfigurationUserDefinedRefDataModalController;